import { render, staticRenderFns } from "./QuickSideTabRight.vue?vue&type=template&id=213058b7&"
import script from "./QuickSideTabRight.vue?vue&type=script&lang=ts&"
export * from "./QuickSideTabRight.vue?vue&type=script&lang=ts&"
import style0 from "./QuickSideTabRight.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports